import { REACT_APP_API_URL } from 'config';
import { usingMockServer } from 'utils/init';
import { z } from 'zod';

export const channelInfoIdKey = 'channelIdInfo';

export const apiBaseUrl = usingMockServer()
  ? import.meta.env.BASE_URL
  : REACT_APP_API_URL;

export const baseResponseSchema = z.object({
  status: z.string(),
  channel: z.number(),
  requestId: z.string(),
  datetime: z.string(),
});

export type BaseResponse = z.infer<typeof baseResponseSchema>;

export const baseErrorResponseSchema = baseResponseSchema.extend({
  error: z.object({
    type: z.string(),
    message: z.string().optional(),
    errorInfos: z.any().optional(),
  }),
});

export type BaseErrorResponse = z.infer<typeof baseErrorResponseSchema>;

export const isValidErrorResponse = (
  error: unknown,
): error is BaseErrorResponse =>
  baseErrorResponseSchema.safeParse(error).success;
